<template>
  <div class="notes-container">
    <div class="notes-header">
      <h2>Notas</h2>
      <br />
    </div>

    <div class="notes-content">
      <textarea
        v-model="notes"
        placeholder="Escriba sus notas aquí..."
        class="notes-textarea"
        @input="saveNotes"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotesView',
  data() {
    return {
      notes: '',
    }
  },
  created() {
    this.loadNotes()
  },
  methods: {
    saveNotes() {
      localStorage.setItem('nexo-vue-notes', this.notes)
    },
    loadNotes() {
      const savedNotes = localStorage.getItem('nexo-vue-notes')
      if (savedNotes) {
        this.notes = savedNotes
      }
    },
    clearNotes() {
      if (
        confirm(
          '¿Está seguro de que desea borrar todas las notas? Esta acción no se puede deshacer.'
        )
      ) {
        this.notes = ''
        this.saveNotes()
      }
    },
    // Method to be called from parent component for resetting
    resetNotes() {
      this.notes = ''
      localStorage.removeItem('nexo-vue-notes')
    },
  },
}
</script>

<style scoped>
.notes-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #202225;
}

.notes-header {
  padding: 20px 20px 20px 80px;
  background-color: #2f3136;
  border-bottom: 1px solid #40444b;
  flex-shrink: 0;
}

.notes-header h2 {
  margin: 0 0 8px 0;
  color: #ffffff;
  font-size: 24px;
}

.notes-description {
  margin: 0;
  color: #b9bbbe;
  font-size: 14px;
}

.notes-content {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.notes-textarea {
  flex: 1;
  width: 100%;
  min-height: 400px;
  padding: 16px;
  border: 1px solid #40444b;
  border-radius: 8px;
  background-color: #2f3136;
  color: #dcddde;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  resize: none;
  outline: none;
  box-sizing: border-box;
}

.notes-textarea:focus {
  border-color: #5865f2;
  background-color: #36393f;
}

.notes-textarea::placeholder {
  color: #72767d;
}

/* Responsive Styles for Mobile */
@media (max-width: 768px) {
  .notes-header {
    padding: 16px 16px 16px 70px;
  }

  .notes-header h2 {
    font-size: 20px;
  }

  .notes-content {
    padding: 16px;
  }

  .notes-textarea {
    font-size: 16px; /* Prevent auto-zoom on mobile */
    min-height: 300px;
  }
}
</style>
